import * as React from "react";

import { IRegistration } from "../../classes/registration";
import { IText_EventViews } from "../../classes/text";

export interface IRegistrationProps {
  registration: IRegistration;
  registerForEventFromService: () => any;
  unregisterFromEvent: () => any;
  eventViewText: IText_EventViews;
}

export const RegistrationDisplaySection = (props: IRegistrationProps) => {
    const deadline = props.registration.deadline;
    const showRegister = props.registration.showRegister;
    const showUnregister = props.registration.showUnregister;
    const registrationInfo = props.registration.registrationInfo;

    const onUnregister = (e) => {
        e.preventDefault();
        props.unregisterFromEvent();
    };

    const onRegister = (e) => {
        e.preventDefault();
        props.registerForEventFromService();
    };

    return (
        <div className="CAL-EVENT-cR-content">
        ZZZ
            <div className="CAL-EVENT-cR-c-stacked">
                <strong>{props.eventViewText.registrationDeadline} </strong>{deadline}
            </div>
            {showRegister &&
                <div style={{ paddingTop: "5px" }}>
                    <a className="CMS_pickButton" href="#" onClick={onRegister}>{props.eventViewText.register}</a>
                </div>
            }                        
            {showUnregister &&
                <div>
                    {registrationInfo} 
                    <a className="CMS_pickButton CMS_pbDelete CMS_pbMarginL" href="#" onClick={onUnregister}>{props.eventViewText.unregister}</a>
                </div>
            }
            {(!showUnregister && registrationInfo) &&
                <div>{registrationInfo}</div>
            }
        </div>
    );
};
